import config from '@/dataroom/app/config/config';
import colors from '@dealroadshow/uikit-styles/variables/colors.module';

export const dataroomGradientColorMapping = {
  [config.tenant.tenantDealvdr.code]: colors.gradientDealvdr,
  [config.tenant.tenant17g5.code]: colors.gradient17g5,
  [config.tenant.tenantInvestorSet.code]: colors.gradientInvestorset,
  [config.tenant.tenantVeriSend.code]: colors.gradientVerisend,
  [config.tenant.tenantResearchRoom.code]: colors.gradientResearchRoom,
  [config.tenant.tenantLoansend.code]: colors.gradientLoanSend,
};
